<!--已销定采购：订单发起采购页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p v-if="uname"><span>操作人：</span>{{uname}}<span>正在操作</span><span @click="unlock" style="color: blue;cursor: pointer">解除锁定</span>
      </p>
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>系统自动生成</td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <!--<td>{{controlData.adddate}}</td>-->
          <td></td>
          <td align="right">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode" v-if="!item.counter||item.counter!=1"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">供应商：</td>
          <td width="140">{{controlData.pcustomer}}</td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.caddress||''}}</td>
          <td align="right" width="60">联系人：</td>
          <td width="140">{{(controlData.clinkman||"")+" " +(controlData.clinkmantel||"")}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">供应号：</td>
          <td width="140" >
            <el-input v-model="tracknum" size="mini" ref="tracknum" onfocus="this.select()" style="width: 125px"></el-input>
          </td>
          <td align="right">客户名称：</td>
          <td width="220">{{controlData.customername}} {{controlData.linkmantel}}</td>
          <td align="right"></td>
          <td></td>
        </tr>
      </table>
      <table v-for="(item1,indextable) in tableData"
             style="border-collapse:collapse;width:100%;margin-top: 20px">
        <tr class="noborder">
          <td align="left" width="60">销售单号：</td>
          <td align="left" width="150">{{item1.erpserial}}</td>
          <td align="left" width="80">下单日期：</td>
          <td align="left" width="150">{{item1.adddate}}</td>
          <td align="left" width="80"></td>
          <td align="left" width="150"></td>
        </tr>
        <tr>
          <td colspan="7" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0"
                   style="border-collapse:collapse;width:100%;fontSize:'18px'"
                   class="query-table">
              <tr>
                <td v-if=" item !='unitguid'&&item !='packagesize'" style="text-align: center"
                    v-for="item in item1['column']">
                  <span v-if="item!='seedcode'"> {{item}}</span>
                  <span v-else-if="item=='seedcode'">编码</span>
                </td>
              </tr>
              <tr v-for="(item,index) in item1['billmap']" style="cursor:pointer;">
                <td :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                    v-for="(ob,index) in item" v-if="index!=item.length-1&&typeof(ob['packagesize'])=='undefined'">
                  <span v-for="value in ob" v-if="index!=item.length-1">{{value}}</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td width="60">采购单备注：</td>
          <td colspan="6" style="padding-top: 10px;padding-bottom: 10px;text-align: left">
            <el-input  type="textarea" :rows="2" style="width: 70%;" v-model="remark" placeholder="填写给供应商的备注信息"></el-input>
            <el-checkbox v-model="edging" label="供应商代割边" border v-if="ssotoken"></el-checkbox>
            <div v-html="getLiuYan(item1.remark)"></div>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="border:none">
            <table>
              <tr v-for="item in item1['formpropertyData']">
                <td align="left" style="padding-left: 0px;padding-right: 0px;" width="160"
                    v-for="(item2,index) in item">
                  <span style="width:80px;display: inline-block;text-align: right">{{index+"："}}</span>
                  <span style="width:70px;display: inline-block;text-align: left">{{item2}}</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button type="warning" plain :loading="loading"  size="mini" v-if="btnupdatevisible&&dialogSeeVisible&&!uname&&ssotoken&&!UGO" @click="saveDataNotoken" style="float: left">确认采购（线下联系供应商下单）</el-button>
      <el-button @click="cancelClick()"  >取 消</el-button>
      <el-button type="primary" :loading="loading" v-if="btnupdatevisible&&dialogSeeVisible&&!uname" @click="saveData">确认采购</el-button>
    </div>
    <BuyorderDetail ref="BuyorderDetail"></BuyorderDetail>
    <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
    <ewmPay ref="ewmPay1" @UnionPay="afterUnionPay" :ewmpre="'buyorderedit'" @CancelUnionPay="afterCancelUnionPay"></ewmPay>

    <el-dialog title="坏件库中存在相同度数商品，请选项处理方案！" :visible="showbadhandle&&btnupdatevisible&&dialogSeeVisible&&!uname"  center :close-on-click-modal="false" :append-to-body="true" :show-close="false">
       <el-table :data="badhandle" size="mini"  border style="width: 100%;" :row-class-name="tableRowClassName" :stripe="false">
        <el-table-column
          label="R/L" prop="R/L"
          align="center"
          header-align="center"
          width="50">
        </el-table-column>
         <el-table-column
           label="原单号" prop="ordernum" :show-overflow-tooltip="true"
           align="left"  header-align="center"  width="130">
         </el-table-column>
        <!--<el-table-column-->
          <!--label="编码" prop="seedcode" :show-overflow-tooltip="true"-->
          <!--align="left"  header-align="center"  width="50">-->
        <!--</el-table-column>-->
        <el-table-column
          label="名称" prop="产品名称" :show-overflow-tooltip="true"
          align="left"  header-align="center">
        </el-table-column>
        <el-table-column
          label="球镜" prop="球镜"
          align="left"  header-align="center"  width="60">
        </el-table-column>
         <el-table-column
           label="柱镜" prop="柱镜"
           align="left"  header-align="center"  width="60">
         </el-table-column>
         <el-table-column
           label="轴位" prop="轴位"
           align="left"  header-align="center"  width="60">
         </el-table-column>
         <el-table-column
           label="数量" prop="totalnumber"
           align="left"  header-align="center"  width="55">
         </el-table-column>
         <el-table-column
           label="处理方式"
           align="left"  header-align="center"  width="150">
           <template slot-scope="scope">
             <el-select v-model="scope.row.handlemodel" style="width:115px" placeholder="请选择" size="mini">
             <el-option  label="" value=""></el-option>
             <el-option  label="需要采购" value="1"></el-option>
             <el-option  label="使用原片" value="2"></el-option>
             </el-select>
           </template>
         </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelClick()"  >取 消</el-button>
        <el-button type="primary" :loading="loading" v-if="btnupdatevisible&&dialogSeeVisible&&!uname" @click="saveBadhandle">保存方案</el-button>
      </div>
    </el-dialog>

  </el-dialog>
</template>

<script>

  import {buyorderdetail,updateliuyan,lensfrombad} from '@/api/set/csagreement';
  import {login,createOrder,backOrder,getdetailGoods,supplystoreNum} from '@/api/ossi';
  import BuyfromSupplyer from './BuyfromSupplyer';
  import {getRemark} from '@/plugin/ordercommon'
  import BuyorderDetail from '../buyagreement/BuyorderDetail';
  import {isHaveRight} from '@/api/set/authorityset'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import ewmPay from './ewmPay';
  import {isUGO} from '@/api/login';
  import {saveData, getListData, lockremove} from '@/api/set/handlelog';
  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    buyodersave, jxcstorelist
  } from '@/api/set/csagreement';

  export default {
    name: 'BuyorderEdit',
    data() {
      return {
        loading: false,
        ssotoken: "",
        website:"",
        UGO:false,
        ssobuydetail: "",
        dialogSeeVisible: false,
        btnupdatevisible: false,
        lock: false,//锁定订单
        formLabelWidth: '120px',
        groupguid: '',
        hasSplit:[],
        orgOrderInfo:{},
        seedcode: "",
        remark: '',
        cangkucode: '',
        cangkuname: '',
        cstagreements: [],
        independentserial: '',
        tableData: [
          {column: []},
        ],
        tableData1: [],
        unitguid: "",
        column: [],
        controlData: {},
        showtitle1: "none",
        jxcstoreData: [],
        edging:false,
        erpserial: '',
        showbadhandle:false,
        badhandle:[],
        uname: '',//操作人
        userInfoModel: '',//当前缓存
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        bn: '',
        formpropertyData: [],//公共参数数组
        parameter: {},//公共参数
        needbuy:{
          info:'',
          show:0,
          error:false,
        }
      }
    },
    methods: {
      saveBadhandle() {
        var needhandle = [];
        for (let i in this.badhandle) {
          if (!(this.badhandle[i].handlemodel == 1 || this.badhandle[i].handlemodel == 2)) {
            this.$message({
              type: 'warning',
              duration: 1500,
              message: '处理方式必选!'
            });
            return;
          }
          if (this.badhandle[i].handlemodel == 2) {
            needhandle.push(this.badhandle[i]);
          }
        }
        if (needhandle.length > 0) {//选择了原片的
          this.loading=true;
          lensfrombad({jxcforms: JSON.stringify(needhandle),
            cangkuname: this.controlData.cangkuname,
            cangkucode: this.controlData.cangkucode}).then(response => {
            if (response.data.code == 0) {
              if (response.data.type == 1) {//全部使用坏件库 对冲
                this.$emit('bindGrid');
                this.cancelClick();
                this.$message({
                  type: 'success',
                  duration: 1500,
                  message: '处理成功，商品已从坏件库中转出!'
                });
                return;
              }else {//存在需要采购的商品
                this.showbadhandle=false;
                this.hasSplit.push(this.orgOrderInfo.erpserial);
                this.$message({
                  type: 'success',
                  duration: 1500,
                  message: '商品已从坏件库中转出，剩余的商品请继续采购!'
                });
                this.$emit('bindGrid');
                this.initData(this.orgOrderInfo, this.groupguid);
              }
            } else {
              this.$message({
                type: 'warning',
                duration: 1500,
                message: response.data.msg
              });
              this.loading=false;
            }
          });
        } else {
          this.showbadhandle = false;
        }
      },
      tableRowClassName({row, rowIndex}) {
        if (row.handlemodel == 2) {
          return 'success-row';
        }else if (row.handlemodel == 1) {
          return 'warning-row';
        }
        return '';
      },
      //取消
      cancelClick() {
        this.showbadhandle=false;
        this.dialogSeeVisible = false
      },
      //采购成功后解除锁定
      unlock() {
        lockremove({
          erpserial: this.erpserial
        }).then(response => {
          this.lock = true
          this.uname = ''
          //锁定功能(控制发起采购按钮)
          this.handlelog('申请采购');
        })
      },
      //处理日志
      handlelog(casestepname) {
        var handlelog = {}
        handlelog.groupguid=this.controlData.groupguid
        handlelog.erpserial = this.erpserial
        handlelog.isopen = casestepname == '申请采购' ? 0 : 1;
        handlelog.casestepname = casestepname
        if (this.controlData.cangkuname) {
          handlelog.remark = '入' + this.controlData.cangkuname
        }
        saveData(handlelog).then(response => {});
      },
      getTitle() {
        let result = (this.userInfoModel.independentserial?this.userInfoModel.independentfdname:this.userInfoModel.tenantname) + "采购订单"
        return result
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)

          this.showtitle1 = "none"
        })
      },
      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      saveDataNotoken() {
        if (!this.tracknum) {
          this.tracknum='线下联系开单';
          // this.$message({type: 'error', duration: 1500, message: '请填写供应商单号!'});
          // return
        }
        this.saveData('notoken');
      },
      saveData(tokenstatus) {
        this.loading = true;
        if (!this.controlData.cangkucode) {
          this.$message({
            type: 'warning',
            duration: 1500,
            message: '仓库必选!'
          });
          this.loading = false
          return
        }
        var ssoT=this.ssotoken;
        if(tokenstatus&&tokenstatus=='notoken'){
          ssoT=false;
        }
        if (ssoT) {//需要向供应商发起采购
          var ckInfo = {};
          for (let i in this.jxcstoreData) {
            if (this.jxcstoreData[i].cangkucode == this.controlData.cangkucode) {
              ckInfo = this.jxcstoreData[i];
            }
          }
          var remarkend = '{"msg":"' + this.controlData.erpserial + '","date":"","uname":"客户销货单号","type":"客户留言","cusname":"' + this.controlData.cangkuname.replace('仓库', '') + '"}';
          if (this.remark) {
            remarkend += ',{"msg":"' + this.remark + '","date":"","uname":"备注","type":"客户留言"}';
          }
          if (this.edging) {
            remarkend += ',{"msg":"供应商代割边","date":"","uname":"","type":"割边"}';
          }
          var buyRemark = '[' + remarkend + ']';
          if (this.controlData.remark && this.controlData.remark != '[]') {
            buyRemark = '[' + remarkend + ',' + this.controlData.remark.substr(1);
          }
          createOrder({
            cangkucode:this.controlData.cangkucode,
            uname: this.userInfoModel.uname,
            uguid: this.userInfoModel.uguid,
            linkman: ckInfo.applyby,
            linkmantel: ckInfo.tel,
            deliverymode: '配送',
            deliveryaddress: ckInfo.adressdetail,
            formproperty: this.ssobuydetail,
            parentguid: this.controlData.erpserial,
            remark: buyRemark,
          }, this.ssotoken).then(response => {
            if (response.data.code == 0) {
              this.tracknum = response.data.erpserial;
              this.saveBuyData(response.data.price, '上游订单已生成，供应商单号：' + this.tracknum, null);
            } else {
              if (response.data.groupguid) {//打开支付页面
                if(!response.data.paytype=='unionpay'){
                  this.$message({message: '尚未开通支付通道！',type: 'error' });
                  return;
                }
                this.$refs.ewmPay1.show(response.data,this.ssotoken);
              } else {
                if(response.data.msg=='一单只允许出现一个商品！'){
                  this.UGO=false;
                }
                this.$message({message: response.data.msg ? response.data.msg : '提交的商品不存在！',type: 'error' })
                this.loading = false
              }
            }
          });
        } else {
          this.saveBuyData(null, '保存成功！', null);
        }
      },
      afterUnionPay(row){
        this.tracknum = row.erpserial;
        this.saveBuyData(row.price, '支付成功！上游订单已生成，供应商单号：' + this.tracknum + '', row);
      },
      afterCancelUnionPay(row){//撤销支付
        backOrder({
          erpserial: row.erpserial,
          parenterpserial: this.controlData.erpserial
        }, this.ssotoken).then(resDel => {
          this.loading = false;
        });
      },
      saveBuyData(pricelist,message,paydetail) {
        // if (JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
        //   if (!this.tracknum) {
        //     this.$message({
        //       type: 'error',
        //       duration: 1500,
        //       message: '请填写供应商单号!'
        //     });
        //     this.loading = false
        //     return
        //   }
        // }
        //取出对应的表单详情和数量
        for (let j in this.tableData) {
          for (let i = 0; i < this.tableData[j]['billmap'].length; i++) {
            var obj = this.tableData[j]['billmap'][i]
            let num = 0;
            let gysprice = 0;
            let seedcode;
            for (var keyObj in  obj) {
              for (var key in obj[keyObj]) {
                if (key == '数量') {
                  num = obj[keyObj]['数量']
                }

                if (key == 'seedcode') {
                  seedcode = obj[keyObj]['seedcode']
                  if (pricelist) {
                    if(pricelist[seedcode]){
                      gysprice=pricelist[seedcode]
                    }
                  }
                }
              }
            }

            let jxc = {
              unitguid: '',
              num: '',
              gysprice: gysprice,
              orderunitguid: this.tableData[j].unitguid,
              seedinfo: this.tableData[j].seedinfo
            }
            if (num && num > 0) {
              jxc.unitguid = this.tableData[j]['billmap'][i][this.tableData[j]['billmap'][i].length - 1].unitguid
              jxc.num = num;
              if (jxc.unitguid)
                this.tableData1.push(jxc)
            }
          }
        }

        if (this.tableData1.length != 0) {
          buyodersave({
            jxcforms: JSON.stringify(this.tableData1),
            map: JSON.stringify({
              pcustomerserial: this.controlData.pcustomerserial,
              pcustomer: this.controlData.pcustomer,
              cangkuname: this.controlData.cangkuname,
              cangkucode: this.controlData.cangkucode,
              address: this.controlData.address,
              linkman: this.controlData.elinkman,
              linkmantel: this.controlData.elinkmantel,
              remark:this.remark.trim(),
              tracknum: this.tracknum.trim(),
              logisticstracknum: this.logisticstracknum.trim(),
              seedinfo: this.controlData.seedinfo,
              bn: this.bn,
            }),
            cstagreements: JSON.stringify(this.cstagreements)
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: message,
                type: 'success'
              })
              this.handlelog('已发起采购');
              //采购成功后解除锁定
              this.unlock();

              this.$emit('bindGrid');
              this.$emit('print');
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.dialogSeeVisible = false;
          });
        } else {
          this.$message({
            message: '请选择订单',
            type: 'error'
          })
          this.loading = false
        }
      },
      //查看采购单
      lookbuyorderdetail(row, isbuyorder) {
        this.$refs.BuyorderDetail.initData(row, isbuyorder)
        this.$refs.BuyorderDetail.show();
      },
      initData(row, groupguid) {
        this.initForm()
        this.ssotoken = "";
        this.loading = true;
        this.website = "";
        this.ssobuydetail = "";
        this.orgOrderInfo=row;
        this.erpserial = row.erpserial
        isHaveRight({rightguid: row.pcustomerserial, type: '001', flag: 1}).then(response => {//判断是否有采购权限，2018-10-25
          if (!response.data.obj) {
            this.$message({
              duration: 2000,
              type: 'error',
              message: '没有采购权限!'
            })
            this.btnupdatevisible = false
          } else {
            this.btnupdatevisible = true

            //查询订单是否有人正在操作
            getListData({
              erpserial: this.erpserial,
            }).then(response => {
              this.lock = false;//是否有人锁定
              if (response.data.obj.length > 0) {
                //当前登陆人与日志表uname不一致时锁定采购订单
                //发起采购、通知仓库按钮会同时出现，只要有一个在操作需要锁定订单
                for (let i = 0; i < response.data.obj.length; i++) {
                  if (response.data.obj[i].casestepname == '操作通知仓库' || response.data.obj[i].casestepname == '申请采购' || response.data.obj[i].casestepname == '操作通知加工') {
                    this.lock = true;
                    if (response.data.obj[i].uname && this.userInfoModel.uname != response.data.obj[i].uname) {
                      this.uname = response.data.obj[i].uname;
                      break;
                    }
                  }
                }
              }
              //锁定功能(控制发起采购按钮),没有采购权限是不锁定订单
              if (!this.lock && this.btnupdatevisible) {
                this.handlelog('申请采购');
              }
            })
          }
        })

        if (row.bn == '发起采购') {
          this.bn = 1
        } else if (row.bn == '通知仓库') {
          this.bn = 2
        }

        this.tableData1 = [];
        this.cstagreements = [];
        this.groupguid = groupguid
        this.unitguid = row.unitguid
        buyorderdetail({
          unitguid: row.unitguid,
          groupguid: this.groupguid,
          unitgroup: 3,
          pcustomerSerial: row.pcustomerserial
        }).then(response => {
          this.controlData = response.data.obj.detail;
          this.tableData = response.data.obj.goodsDetail;
          this.parameter = response.data.obj.parameter
          this.ssobuydetail = response.data.obj.ssobuydetail;

          if (response.data.obj.ssocode) {
            //执行登录方法
            login({
              idencode: response.data.obj.ssocode,
              tenantid: this.userInfoModel.tenantid,
              independentserial: this.userInfoModel.independentserial
            }).then(loginres => {
              if (loginres.data.code == 0) {
                this.ssotoken = loginres.data.msg;
                this.website = loginres.data.website;
                this.loading = false;
              } else {
                this.$message({message: loginres.data.msg, type: 'error'})
              }
            });
          } else {
            this.loading = false;
          }


          //解析参数
          this.tableData.forEach(o => {
            if (o.parametermap) {
              let biaoji = 0;
              o.formpropertyData = []
              for (let j in o.parametermap) {
                if (biaoji % 4 == 0) {
                  let temp = {}
                  temp[j] = o.parametermap[j]
                  o.formpropertyData.push(temp)
                } else {
                  o.formpropertyData[o.formpropertyData.length - 1][j] = o.parametermap[j]
                }
                biaoji++
              }
            }
          })

          if (response.data.obj.badorder && response.data.obj.badorder.length > 0&&!this.hasSplit.includes(this.orgOrderInfo.erpserial)) {
            this.showbadhandle = true;
            var badRow = response.data.obj.badorder;
            for (let j in badRow) {
              badRow[j].handlemodel = '';
            }
            this.badhandle = badRow;
          }

          this.controlData.cangkucode = ""
          if (this.jxcstoreData && this.jxcstoreData.length > 0) {
            this.controlData.cangkucode = this.jxcstoreData[0].cangkucode
            this.controlData.cangkuname = this.jxcstoreData[0].cangkuname
          }

          for (let g = 0; g < this.tableData.length; g++) {
            //取出表头
            let temparr = []
            let biaoji = 0
            this.column = []

            for (let i in this.tableData[g]['billmap']) {
              var billmaprow = this.tableData[g]['billmap'][i];
              for (let j in this.badhandle) {
                if (this.badhandle[j].hasset || billmaprow["数量"] > 1) continue;
                if (this.badhandle[j].packagesize == billmaprow["packagesize"] && this.badhandle[j].seedcode == billmaprow["seedcode"]) {
                  this.badhandle[j].hasset = true;
                  this.badhandle[j]["R/L"] = billmaprow["R/L"];
                  this.badhandle[j]["产品名称"] = billmaprow["产品名称"];
                  this.badhandle[j]["球镜"] = billmaprow["球镜"];
                  this.badhandle[j]["柱镜"] = billmaprow["柱镜"];
                  this.badhandle[j]["轴位"] = billmaprow["轴位"];
                  this.badhandle[j]["unitguid"] = billmaprow["unitguid"];
                  break;
                }
              }

              for (let j in billmaprow) {
                if (j == "R/L") {
                  biaoji = 1
                }
                if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr) && j != "销售单号" && j != "unitguid") {
                  temparr.push(j)
                }
              }
            }
            //对表头排序

            if (biaoji == 1) {
              this.column.push("R/L")
            }
            this.column.push("seedcode")
            this.column.push("产品名称")
            this.column.push("球镜")
            this.column.push("柱镜")
            this.column.push("轴位")
            this.column = this.column.concat(temparr)
            //this.column.push("销售单号")
            this.column.push("数量")
            this.column.push("unitguid")
            this.tableData[g]['column'] = this.column
            this.tableData[g]['billmap'] = this.tableData[g]['billmap'].map(o1 => this.column.map(o2 => {
              let ob = {}
              ob[o2] = o1[o2]
              return ob
            }))
            this.cstagreements.push(this.tableData[g].unitguid)
          }
          if(this.showbadhandle ){
            var newBadRow=[];
            for (let j in this.badhandle) {
              if (this.badhandle[j].hasset){
                newBadRow.push(this.badhandle[j]);
              }
            }
            this.badhandle=newBadRow;
          }
        });
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }

        this.showbadhandle=false;
        this.badhandle=[];
        this.UGO=isUGO();
        if(this.userInfoModel.mobile=='18362831963'||this.userInfoModel.mobile=='15250395939'||this.userInfoModel.mobile=='18051996163'||this.userInfoModel.mobile=='15050885921'){
          this.UGO=false;
        }
        this.logisticstracknum = ''
        this.tracknum = ''
        this.edging=false;
        this.bn = ''
        this.lock = false;
        this.controlData = {}
        this.cangkucode = ""
        this.cangkuname = ""
        this.cstagreements=[];
        this.btnupdatevisible = false
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.needbuy.show=0;
        this.uname = ''
        this.remark=''
      },

    }
    ,
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
      })
    }
    ,

    components: {
      //CstagreementEditSeedDetail
      BuyorderDetail,
      ewmPay,
      BuyfromSupplyer
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyorderEdit.vue